// extracted by mini-css-extract-plugin
export default {"button":"_3CnYw","navigate":"af4bv","header":"Ug8hN","orderNumber":"ozDHS","placedOn":"_1qrFX","actions":"i1bX8"};